import React, { useState } from "react";
import { UserInvoiceCategory } from "./types";
import useSWR from "swr";
import { useClubSlug } from "components/Clubs/hooks";
import { Form } from "@form/Form";
import FormInput from "@form/FormInput";
import { FilterState, Selection } from "components/DataTable/DataTable";
import Loader from "components/Loader";
import { useTranslation } from "react-i18next";
import useInvoicePath from "./hooks/useInvoicePath";
import { useApi } from "../../hooks/useApi";

interface Props {
    filter?: FilterState;
    invoices?: Selection;
    clubSlug?: string;
    callback?: () => void;
}

const DuplicateMultipleAssistant = ({ filter, invoices, clubSlug: _clubSlug, callback }: Props) => {
    const { t } = useTranslation("invoice");
    const api = useApi();
    const clubSlug = useClubSlug(_clubSlug);
    const { data, isLoading: categoriesIsLoading } = useSWR<{ data: UserInvoiceCategory[] }>(
        `invoice/${clubSlug}/category/all`
    );
    const categories = data?.data || [];
    const [isLoading, setIsLoading] = useState(false);
    const [path] = useInvoicePath();

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `invoice/${clubSlug}/duplicate`,
            method: "POST",
            data: {
                ...data,
                filter,
                invoices,
                selectedCategory: path,
            },
            onBefore: () => setIsLoading(false),
            onSuccess: callback,
        });
    };

    return (
        <Loader isLoading={categoriesIsLoading}>
            <Form onSubmit={handleSubmit}>
                <FormInput.AutoComplete
                    dataKey="id"
                    labelKey="title"
                    data={categories}
                    name="category"
                    label={t("duplicateMultiple.moveTo")}
                    positionFixed
                    allowNew
                    newSelectionPrefix={t("duplicateMultiple.newCategoryPrefix")}
                />
                <FormInput.Submit isLoading={isLoading}>{t("duplicateMultiple.submit")}</FormInput.Submit>
            </Form>
        </Loader>
    );
};

export default DuplicateMultipleAssistant;
